import { formatISO } from "date-fns";
import { FetchParams } from "../hooks/utility-hoks/useFetchWithToken";

type OccupancyEntryV2 = {
  timestamp: string;
  occupancy: number;
};

type GetOccupancyDataResponseEntries = {
  id: string;
  entries: OccupancyEntryV2[];
};

type GetOccupancyDataResponseBody = {
  sensors: GetOccupancyDataResponseEntries[];
};

export type GetOccupancyDataResponse = {
  statusCode: number;
  body: GetOccupancyDataResponseBody;
};

export const getOccupancy = (
  locationName: string,
  startTime: Date,
  period: "day" | "hour" = "hour",
  sensorFilter: string | null,
): FetchParams => {
  let url = "https://api.rmcounting.no/v3/data/occupancy";
  url += `?name=${encodeURIComponent(locationName)}`;
  url += `&startTime=${encodeURIComponent(formatISO(startTime))}`;
  url += `&period=${period}`;
  return { url };
};
